export const getSaasUrl = () => {
  const hostname = window.location.hostname;
  if (hostname === "localhost" || hostname === "127.0.0.1") {
    return "https://app.dev.strikeaprice.com/register";
  } else if (hostname.includes("dev.strikeaprice.com")) {
    return "https://app.dev.strikeaprice.com/register";
  } else {
    return "https://app.strikeaprice.com/register";
  }
};
